import { BRAND } from "@/lib/brand";
import { Mail, Globe, ArrowUpRight } from "lucide-react";
import { SiFacebook, SiInstagram, SiTiktok } from "react-icons/si";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center">
              <img
                src={BRAND.logo}
                alt={BRAND.name}
                className="h-28 w-28 object-contain"
              />
            </div>
            <p className="mt-6 font-display font-bold text-2xl lg:text-3xl text-white tracking-tight max-w-md">
              Where Vision Meets Sound.
            </p>
            <p className="mt-4 font-body text-white/55 max-w-md leading-relaxed">
              Production, arranging and engineering by {BRAND.producer}.
              Available for live captures, studio sessions, mixes and masters
              worldwide.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-body text-[11px] uppercase tracking-[0.25em] text-white/40">
              Contact
            </p>
            <ul className="mt-5 space-y-4">
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  data-testid="footer-email"
                  className="group inline-flex items-center gap-3 font-display font-bold text-white hover:text-brand-magenta transition-colors"
                >
                  <Mail size={16} />
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  href={`https://${BRAND.domain}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-domain"
                  className="group inline-flex items-center gap-3 font-display font-bold text-white hover:text-brand-orange transition-colors"
                >
                  <Globe size={16} />
                  {BRAND.domain}
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-body text-[11px] uppercase tracking-[0.25em] text-white/40">
              Follow
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href={BRAND.socials.facebook}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-social-facebook"
                aria-label="Facebook"
                className="group h-12 w-12 rounded-full border border-white/15 bg-white/[0.03] flex items-center justify-center text-white hover:bg-[#1877F2] hover:border-[#1877F2] transition-all"
              >
                <SiFacebook size={18} />
              </a>
              <a
                href={BRAND.socials.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-social-instagram"
                aria-label="Instagram"
                className="group h-12 w-12 rounded-full border border-white/15 bg-white/[0.03] flex items-center justify-center text-white hover:bg-gradient-to-br hover:from-fuchsia-500 hover:to-orange-500 hover:border-transparent transition-all"
              >
                <SiInstagram size={18} />
              </a>
              <a
                href={BRAND.socials.tiktok}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-social-tiktok"
                aria-label="TikTok"
                className="group h-12 w-12 rounded-full border border-white/15 bg-white/[0.03] flex items-center justify-center text-white hover:bg-white hover:text-black hover:border-white transition-all"
              >
                <SiTiktok size={18} />
              </a>
            </div>

            <a
              href="#quote"
              data-testid="footer-cta-quote"
              className="mt-10 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-black font-display font-bold hover:bg-brand-magenta hover:text-white transition-all"
            >
              Start a project
              <ArrowUpRight size={16} />
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex items-center justify-between flex-wrap gap-4">
          <p className="font-body text-xs text-white/40">
            © {year} {BRAND.name}. All rights reserved.
          </p>
          <p
            data-testid="footer-credit"
            className="font-body text-xs text-white/40"
          >
            Vision Brought to Life by{" "}
            <a
              href="https://vzngfx.com"
              target="_blank"
              rel="noreferrer"
              className="text-white/70 hover:text-brand-magenta transition-colors font-medium"
            >
              VZNGFX
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
